const receiptMimeTypesByExtension = {
    pdf: 'application/pdf',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    webp: 'image/webp',
    bmp: 'image/bmp',
    svg: 'image/svg+xml',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    csv: 'text/csv',
    txt: 'text/plain',
};

export const receiptImageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'];

export const getReceiptFileExtension = (fileName = '') => (
    String(fileName || '').split(/[?#]/)[0].split('.').pop().toLowerCase()
);

export const getExpenseProofUrl = (fileName = '') => (
    `${process.env.REACT_APP_BASE_URL}/v2/expenseProof/${encodeURIComponent(String(fileName || ''))}`
);

export const getReceiptContentType = (fileName = '', responseContentType = '', blobContentType = '') => {
    const headerContentType = String(responseContentType || blobContentType || '').split(';')[0].toLowerCase();
    if (headerContentType && headerContentType !== 'application/octet-stream') {
        return headerContentType;
    }

    return receiptMimeTypesByExtension[getReceiptFileExtension(fileName)] || headerContentType;
};

export const createTypedReceiptBlob = (blob, contentType = '') => {
    if (!blob || !contentType || blob.type === contentType) return blob;
    return blob.slice(0, blob.size, contentType);
};
